var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 131,
    viewBox: "0 0 150 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 150,
    height: 130,
    rx: 50,
    fill: "#352750",
    fillOpacity: 0.47
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2561_35747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5 29.5C80.2209 29.5 84.7484 31.3701 88.0865 34.6989C91.4246 38.0276 93.3 42.5424 93.3 47.25C93.3 51.9576 91.4246 56.4724 88.0865 59.8011C84.7484 63.1299 80.2209 65 75.5 65C70.7791 65 66.2516 63.1299 62.9135 59.8011C59.5753 56.4724 57.7 51.9576 57.7 47.25C57.7 42.5424 59.5753 38.0276 62.9135 34.6989C66.2516 31.3701 70.7791 29.5 75.5 29.5ZM36.5625 38.375C39.6358 38.375 42.125 40.8572 42.125 43.9219V49.4688V60.5625V66.1371C42.125 68.4945 43.0567 70.7549 44.7255 72.4189L51.8316 79.5051C52.9858 80.6561 54.7936 80.8363 56.1425 79.935C57.9364 78.7424 58.1867 76.2047 56.657 74.6932L54.5433 72.5854L50.0933 68.1479C48.355 66.4145 48.355 63.5994 50.0933 61.866C51.8316 60.1326 54.6545 60.1326 56.3928 61.866L60.8428 66.3035L62.9566 68.4113L66.4748 71.9197C69.3952 74.8318 71.0361 78.784 71.0361 82.9025V93.8438C71.0361 97.5186 68.0462 100.5 64.3611 100.5H55.0995C52.7355 100.5 50.4688 99.5709 48.8 97.9068L34.9077 84.0535C32.4045 81.5574 31 78.1738 31 74.6377V60.5625V51.6875V43.9219C31 40.8572 33.4892 38.375 36.5625 38.375ZM114.438 38.375C117.511 38.375 120 40.8572 120 43.9219V51.6875V60.5625V74.6377C120 78.1738 118.595 81.5574 116.092 84.0535L102.2 97.9068C100.531 99.5709 98.2645 100.5 95.9005 100.5H86.625C82.9398 100.5 79.95 97.5186 79.95 93.8438V82.9025C79.95 78.784 81.5909 74.8318 84.5112 71.9197L88.0295 68.4113L90.1433 66.3035L94.5933 61.866C96.3316 60.1326 99.1545 60.1326 100.893 61.866C102.631 63.5994 102.631 66.4145 100.893 68.1479L96.4428 72.5854L94.3291 74.6932C92.7994 76.2186 93.0497 78.7424 94.8436 79.935C96.1925 80.8363 98.0003 80.6561 99.1545 79.5051L106.261 72.4189C107.929 70.7549 108.861 68.4945 108.861 66.1371V60.5625V49.4688V43.9219C108.861 40.8572 111.35 38.375 114.424 38.375H114.438Z",
    fill: "#230F4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2561_35747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 71,
    fill: "white",
    transform: "translate(31 29.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrity);
export default __webpack_public_path__ + "static/media/Integrity.b5e368073e3b36da1dbea1a10a754deb.svg";
export { ForwardRef as ReactComponent };